import LayoutBasic from "@/views/layouts/LayoutBasic";
import CodSenders from "@/views/cod/Senders";
import CodOrders from "@/views/cod/Orders";
import SentOrders from "@/views/cod/Sent";

const routes =   {
  path: '/cod',
  component: LayoutBasic, // Change the desired Layout here,
  meta: {requiresAuth: true},
  children: [
    {
      path: 'senders',
      component: CodSenders,
      name: 'CodSenders',
      meta: {
        // allowedTo: [ROLES.ID.SuperAdmin],
        permission: 'cod/senders'
      }
    },
    {
      path: 'orders',
      component: CodOrders,
      name: 'CodOrders',
      meta: {
        // allowedTo: [ROLES.ID.SuperAdmin],
        permission: 'cod/orders'
      }
    },
    {
      path: 'sent',
      component: SentOrders,
      name: 'SentOrders',
      meta: {
        // allowedTo: [ROLES.ID.SuperAdmin],
        permission: 'cod/sent'
      }
    },
  ]
}

export default routes;
